import PageHeader from '@/components/common/PageHeader';
import { useCallback, useState } from 'react';
import CorporationSelectList from '@components/page/CorporationSelectList';
import SeasonList from '@components/page/SeasonList';
import { CorporationListItem } from '@/api/corporation/type';

const Season = () => {
    const [item, setItem] = useState<CorporationListItem | undefined>(
        undefined,
    );

    const onCorporationChange = useCallback((row: CorporationListItem) => {
        console.log('클릭된 행:', row.userIdx);
        setItem(row);
    }, []);

    return (
        <>
            <PageHeader
                title="생육작기 관리"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '생육관리' },
                    { label: '생육작기 관리', active: true },
                ]}
            />

            <div className="row mt-4">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-12 col-md-3">
                            <CorporationSelectList
                                onRowChange={onCorporationChange}
                            />
                        </div>
                        <div className="col-12 col-md-9">
                            {item !== undefined && (
                                <SeasonList
                                    key={item.userIdx}
                                    userIdx={item.userIdx}
                                    userName={item.userName}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Season;
